import { Serializable } from '../../../core/models/serializable';
import { ProductType } from './product-type';
export class ProductModel implements Serializable<ProductModel> {
  fromObject(obj: any): ProductModel {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public productId: number;

  public type: ProductType;

  public name: string;

  public isActive: boolean;

  public isInStock: boolean;

  public createDate: Date;
}
